export default "__VITE_ASSET__DPW24rUu__"